module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "root",
    staticClass: "dof-gear weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-touchmove": ""
    },
    on: {
      "touchmove": function($event) {
        $event.stopPropagation();
        return _vm.onTouchMove($event)
      }
    }
  }, [_vm._l((_vm.ranges), function(v, i) {
    return [_c('div', {
      key: i,
      ref: "bar",
      refInFor: true,
      staticClass: "dof-gear-item weex-ct weex-div",
      attrs: {
        "weex-type": "div",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          return (function () { return _vm.onClick(v); })($event)
        }
      }
    }, [(!_vm.readonly) ? _c('div', {
      staticClass: "dof-gear-item-anchor weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, [_c('div', {
      staticClass: "dof-gear-item-anchor-angle weex-ct weex-div",
      style: (_vm._px2rem(_vm.getAngleStyle(v), 75)),
      attrs: {
        "weex-type": "div"
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "dof-gear-item-track weex-ct weex-div",
      style: (_vm._px2rem(_vm.trackStyle, 75)),
      attrs: {
        "weex-type": "div"
      }
    }, [_c('div', {
      staticClass: "dof-gear-item-bar weex-ct weex-div",
      style: (_vm._px2rem(_vm.getBarStyle(v), 75)),
      attrs: {
        "weex-type": "div"
      }
    })]), _vm._v(" "), (v.gear) ? _c('p', {
      staticClass: "dof-gear-item-gear weex-el weex-text",
      style: (_vm._processExclusiveStyle(_vm.gearStyle, 75, 'text')),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(v.gear))]) : _vm._e()]), _vm._v(" "), (!_vm.isLast(i)) ? _c('div', {
      key: ("gap-" + i),
      staticClass: "dof-gear-gap weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }) : _vm._e()]
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-225d914a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-225d914a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-gear/index.vue
// module id = 578
// module chunks = 0 1